// Fallback defaults for the landing page (mirrors backend DEFAULT_HOME).
// Home renders these instantly, then overrides with saved content from /api/content/home.
export const DEFAULT_HOME = {
  hero_eyebrow: "Corporate Advisory",
  hero_title: "A considered approach to",
  hero_title_accent: "capital, energy",
  hero_title_end: "and the climate economy.",
  hero_subtitle:
    "Sunly Prime is a corporate advisory entity that brings together cross-industry expertise across energy, aviation and carbon markets.",
  hero_image:
    "https://images.unsplash.com/photo-1552072232-059f1a5d76c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjBibHVlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mzg5OTUyM3ww&ixlib=rb-4.1.0&q=85",
  hero_cta_primary: "Engage Us",
  hero_cta_secondary: "Who We Are",
  intro_eyebrow: "Our Origin",
  intro_heading:
    "Originally envisioned to support the Sunly Properties group \u2014 now an independent corporate advisory entity.",
  intro_body:
    "We bring together experienced people from different industries to consider opportunities carefully and to support well-structured, responsible ventures. Our approach favours discretion, diligence and long-term relationships over noise.",
  services_eyebrow: "Our Services",
  services_heading: "Six disciplines, one considered standard.",
  service_1_kicker: "Carbon Markets",
  service_1_title: "iRECS & Carbon Markets",
  service_1_body:
    "Advisory across international renewable energy certificates and considered participation in high-integrity carbon markets.",
  service_1_sub_1: "I-REC registration advisory",
  service_1_sub_2: "Carbon credit strategy",
  service_1_sub_3: "Market readiness & procurement",
  service_1_image:
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsJTIwY2xlYW4lMjBlbmVyZ3klMjBjYXJib24lMjBjcmVkaXR8ZW58MHx8fHwxNzkwNzk2ODc3fDA&ixlib=rb-4.1.0&q=85",
  service_2_kicker: "Digital Assurance",
  service_2_title: "Blockchain Audits",
  service_2_body:
    "Independent review and verification support for blockchain-based systems and digital asset structures.",
  service_2_sub_1: "Smart-contract review support",
  service_2_sub_2: "On-chain verification",
  service_2_sub_3: "Digital asset due diligence",
  service_2_image:
    "https://images.unsplash.com/photo-1639322537231-2f206e06af84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxibG9ja2NoYWluJTIwdGVjaCUyMGFic3RyYWN0JTIwc2VydmVyJTIwZGFya3xlbnwwfHx8fDE3OTA3OTY4NzN8MA&ixlib=rb-4.1.0&q=85",
  service_3_kicker: "Public Programmes",
  service_3_title: "Government Grant Arrangements",
  service_3_body:
    "Structured support in identifying, arranging and administering government grant and incentive programmes.",
  service_3_sub_1: "Grant identification & screening",
  service_3_sub_2: "Application structuring",
  service_3_sub_3: "Compliance & reporting advisory",
  service_3_image:
    "https://images.unsplash.com/photo-1788720561050-d4d7109996c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxpbnN0aXR1dGlvbmFsJTIwZGFyayUyMGFyY2hpdGVjdHVyZSUyMGdvdmVybm1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA3OTY4NzN8MA&ixlib=rb-4.1.0&q=85",
  service_4_kicker: "Long-Horizon Capital",
  service_4_title: "Patient Capital & Investment Readiness Coaching",
  service_4_body:
    "Preparation and coaching for sponsors seeking patient, long-horizon capital partners.",
  service_4_sub_1: "Long-horizon capital structuring",
  service_4_sub_2: "Investor-readiness preparation",
  service_4_sub_3: "Governance & reporting discipline",
  service_4_image:
    "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBib2FyZCUyMG1lZXRpbmclMjBtZW50b3JzaGlwJTIwYWR2aXNvcnklMjBsdXh1cnl8ZW58MHx8fHwxNzkwNzk2ODczfDA&ixlib=rb-4.1.0&q=85",
  service_5_kicker: "Energy Transition",
  service_5_title: "Waste2Energy: Design, Deployment & Capital Raise",
  service_5_body:
    "End-to-end advisory for waste-to-energy ventures, from early design through deployment and capital raising.",
  service_5_sub_1: "Concept & design advisory",
  service_5_sub_2: "Deployment & partner coordination",
  service_5_sub_3: "Capital raise structuring",
  service_5_image:
    "https://images.unsplash.com/photo-1772376920750-dac1470b1bad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZW5lcmd5JTIwZmFjaWxpdHklMjB3YXN0ZSUyMHRvJTIwZW5lcmd5fGVufDB8fHx8MTc5MDc5Njg3M3ww&ixlib=rb-4.1.0&q=85",
  service_6_kicker: "Trade Finance",
  service_6_title: "SBLC Matching & Integration",
  service_6_body:
    "Considered matching and integration of standby letters of credit within wider capital structures.",
  service_6_sub_1: "Instrument matching advisory",
  service_6_sub_2: "Banking counterparty coordination",
  service_6_sub_3: "Integration & documentation support",
  service_6_image:
    "https://images.unsplash.com/photo-1609358905581-e5381612486e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx0cmFkZSUyMGZpbmFuY2UlMjBiYW5raW5nJTIwdmF1bHQlMjBsdXh1cnl8ZW58MHx8fHwxNzkwNzk2ODc3fDA&ixlib=rb-4.1.0&q=85",
  principle_1_title: "Discretion",
  principle_1_label: "We operate quietly and confidentially.",
  principle_2_title: "Expertise",
  principle_2_label: "Cross-industry perspective on every question.",
  principle_3_title: "Alignment",
  principle_3_label: "We sit on the same side as our partners.",
  principle_4_title: "Integrity",
  principle_4_label: "A single, non-negotiable standard.",
  cta_eyebrow: "Get In Touch",
  cta_heading: "We welcome a considered conversation.",
  cta_body:
    "If you would like to learn more about Sunly Prime, we would be glad to hear from you.",
  cta_button: "Connect With Sunly Prime",
};

export default DEFAULT_HOME;

export const DEFAULT_ABOUT = {
  hero_eyebrow: "Who We Are",
  hero_title: "More than an entity. A quiet home for considered capital.",
  hero_image:
    "https://images.unsplash.com/photo-1552072232-059f1a5d76c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjBibHVlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mzg5OTUyM3ww&ixlib=rb-4.1.0&q=85",
  story_eyebrow: "The Story",
  story_heading: "From a group capability to an independent advisory house.",
  story_p1:
    "Sunly Prime was originally envisioned as a corporate entity to support the businesses of the Sunly Properties group. Over time, our remit has broadened.",
  story_p2:
    "Today, Sunly Prime brings together experienced people from different industries to consider opportunities across energy, aviation and related sectors \u2014 and to support well-structured, responsible ventures.",
  story_p3:
    "We take a long-term view, with a particular interest in the emerging landscape of high-integrity carbon markets. We prefer to let our work speak quietly, and to build relationships that endure.",
  values_eyebrow: "How We Operate",
  values_heading: "The principles behind every mandate.",
  value_1_title: "Integrity First",
  value_1_body:
    "We hold ourselves to a single, non-negotiable standard. Discretion and diligence come before anything else.",
  value_2_title: "Cross-Industry Talent",
  value_2_body:
    "We bring together people with different perspectives \u2014 because the best questions rarely sit within one discipline.",
  value_3_title: "Aligned Interests",
  value_3_body:
    "We prefer to sit on the same side of the table as those we work with, and to build relationships that last.",
  value_4_title: "Considered Approach",
  value_4_body:
    "We take our time, look carefully, and support only what we believe in. Quality over noise.",
  cta_heading: "Meet the people behind Sunly Prime.",
  cta_button: "View Directors",
};

export const DEFAULT_CONNECT = {
  eyebrow: "Connect",
  title: "Let's structure something significant.",
  subtitle:
    "Whether you are a project sponsor, an institutional funder or a prospective partner, we welcome a confidential conversation.",
  email: "admin@sunlyprime.asia",
  online: "sunlyprime.asia",
};

export const DEFAULT_DIRECTORS_PAGE = {
  eyebrow: "Directors' Biosketches",
  title: "The people behind Sunly Prime.",
  subtitle:
    "Sunly Prime is defined by the people who guide it. Full biosketches for our leadership team will be published here.",
};

export const DEFAULT_PROJECTS_PAGE = {
  eyebrow: "Private Area",
  title: "Areas of focus.",
  subtitle:
    "A private overview for our clients and partners. Specific engagement details are shared directly and confidentially.",
};
